import type { EngineBand, MoveAssessment, TacticalStatus } from "../lessons/schema.ts";

export const QUALITY_BAND_IDS = [
  "best-practical",
  "strong-alternative",
  "playable",
  "questionable",
  "tactical-error",
  "not-analyzed",
] as const;

export type QualityBandId = (typeof QUALITY_BAND_IDS)[number];

export const QUALITY_BANDS: Record<QualityBandId, { label: string; short: string }> = {
  "best-practical": { label: "Best practical", short: "Best" },
  "strong-alternative": { label: "Strong alternative", short: "Strong" },
  playable: { label: "Playable", short: "Playable" },
  questionable: { label: "Questionable", short: "Questionable" },
  "tactical-error": { label: "Tactical error", short: "Tactical" },
  "not-analyzed": { label: "Engine not checked", short: "Unchecked" },
};

/**
 * Map the independent engine/tactical axes onto a single display band.
 * Tactics win when the move hangs something; otherwise use the engine band.
 * Book/plan stay on their own chips and are never folded in here.
 */
export function qualityBandFromAssessment(
  assessment: MoveAssessment | null | undefined
): QualityBandId {
  if (!assessment) return "not-analyzed";

  const tactical: TacticalStatus = assessment.tactical.status;
  if (tactical === "losing") return "tactical-error";
  if (tactical === "questionable") return "questionable";

  const band: EngineBand = assessment.engine.band;
  if (band === "top") return "best-practical";
  if (band === "equivalent") return "strong-alternative";
  if (band === "playable") return "playable";
  if (band === "inferior") return "questionable";
  return "not-analyzed";
}

export function qualityBandLabel(id: QualityBandId): string {
  return QUALITY_BANDS[id].label;
}
